// removed by extract-text-webpack-plugin
module.exports = {"background":"src-components-Cta----Cta-module---background---3X0bD","fade":"src-components-Cta----Cta-module---fade---GsUMp","content":"src-components-Cta----Cta-module---content---1HIkt","categories-item":"src-components-Cta----Cta-module---categories-item---2Q1jw","title":"src-components-Cta----Cta-module---title---1BJI9","link":"src-components-Cta----Cta-module---link---14q9l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cta/Cta.module.scss
// module id = 1174
// module chunks = 168707334958949